import { AxiosResponse } from 'axios';

import Resolver from 'src/common/Resolver';
import useParticipantsStore from 'src/stores/participantsStore';
import ClaimParticipants from './ClaimParticipants';

const ClaimParticipantsResolver = () => {
  const { fetchMyParticipants, fetchMyPendingClaims } = useParticipantsStore();

  const loadDependencies = () => {
    const deps: Array<Promise<void | AxiosResponse<unknown>>> = [
      fetchMyParticipants(),
      fetchMyPendingClaims(),
    ];
    return Promise.all(deps);
  };

  return <Resolver resolve={loadDependencies} successComponent={ClaimParticipants} />;
};

export default ClaimParticipantsResolver;
